export default __webpack_public_path__ + "meetingrooms.json";